import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import YearGroupPerformanceAnalytics from "./routes/YearGroupPerformanceAnalytics";
import SubjectPerformanceAnalytics from "./routes/SubjectPerformanceAnalytics";
import ClassPerformanceAnalytics from "./routes/ClassPerformanceAnalytics";
import StaffPerformanceAnalytics from "./routes/StaffPerformanceAnalytics";
import StudentPerformanceAnalytics from "./routes/StudentPerformanceAnalytics";
import LearningCoursePerformanceAnalytics from "./routes/LearningCoursePerformanceAnalytics";

export default store => {
  return {
    path: "performance",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "performance" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      YearGroupPerformanceAnalytics(store),
      SubjectPerformanceAnalytics(store),
      ClassPerformanceAnalytics(store),
      StaffPerformanceAnalytics(store),
      StudentPerformanceAnalytics(store),
      LearningCoursePerformanceAnalytics(store),
    ],
  };
};
